"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormInputGroup", {
    enumerable: true,
    get: function() {
        return FormInputGroup;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _FormInputGroupContext = require("./FormInputGroupContext");
const _useInputBorderCss = require("../useInputBorderCss");
const _Theme = require("../../../contexts/Theme");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const FormInputGroup = /*#__PURE__*/ _react.default.forwardRef((param, ref)=>{
    let { children, className = "", rounded, direction = "row", ...props } = param;
    const borderCss = (0, _useInputBorderCss.useInputBorderCss)({
        rounded
    });
    const [focused, setFocused] = (0, _react.useState)(false);
    const [hasPrefix, setHasPrefix] = (0, _react.useState)(false);
    const [hasSuffix, setHasSuffix] = (0, _react.useState)(false);
    const { colors } = (0, _Theme.useTheme)();
    return /*#__PURE__*/ _react.default.createElement("div", {
        ...props,
        onFocus: setFocused.bind(null, true),
        onBlur: setFocused.bind(null, false),
        ref: ref,
        className: _style.default.dynamic([
            [
                "cb30d27ccedf266f",
                [
                    direction,
                    colors.white
                ]
            ]
        ]) + " " + "".concat(className, " ").concat(focused ? "focus-in" : "focus-out", " ").concat(borderCss.className)
    }, /*#__PURE__*/ _react.default.createElement(_FormInputGroupContext.FormInputGroupContext.Provider, {
        value: {
            inGroup: true,
            hasPrefix,
            hasSuffix,
            setHasPrefix,
            setHasSuffix,
            rounded,
            direction
        }
    }, children), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "cb30d27ccedf266f",
        dynamic: [
            direction,
            colors.white
        ]
    }, "div.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-flex-direction:".concat(direction, ";-ms-flex-direction:").concat(direction, ";flex-direction:").concat(direction, ";background:").concat(colors.white, "}")), borderCss.styles);
});
FormInputGroup.displayName = "FormInputGroup";

//# sourceMappingURL=FormInputGroup.js.map